import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useSearchQuery = (payload, options = {}) => {
  const api = useMatiApiClient('search')

  const { query, filters } = payload

  const enabled = query !== undefined && filters.length > 0

  return useQuery({
    queryKey: ['facets', payload],
    queryFn: () => api.search(payload),
    enabled,
    ...options
  })
}
